'use strict';

import timestamp from './timestamp';


export default function(incident) {
	timestamp(incident);

	if (!incident.timestamps.acknowledged) {
		incident.state = 'new';
		incident.stateTime = incident.time;
		return;
	}

	function Q() {
		for (var i = 0, nbArgs = arguments.length; i < nbArgs; i++) {
			var entry = incident.timestamps[arguments[i]];
			if (entry) return entry.time;
		}
		return false;
	}

	if (incident.completed) {
		if (incident.state != 'completed') {
			incident.state = 'completed';
			incident.stateTime = new Date();
		}
	} else if (incident.archived) {
		if (incident.state != 'archived') {
			incident.state = 'archived';
			incident.stateTime = new Date();
		}
	} else if (Q('form_skipped')) {
		incident.state = 'awaiting approval';
		incident.stateTime = Q('form_skipped');
	} else if (Q('team:done')) {
		incident.state = 'form required';
		incident.stateTime = Q('team:done');
	} else if (Q('geo:returned_to_shop', 'geo:location_skipped')) {
		incident.state = 'work completed';
		incident.stateTime = Q('geo:returned_to_shop', 'geo:location_skipped');
	} else if (Q('geo:departed', 'geo:shop_return_skipped')) {
		incident.state = 'returning to the shop';
		incident.stateTime = Q('geo:departed', 'geo:shop_return_skipped');
	} else if (Q('geo:arrived')) {
		incident.state = 'working';
		incident.stateTime = Q('geo:arrived');
	} else if (
		Q('geo:at_shop', 'geo:at_shop_skipped')
		&&
		Q('team:formed', 'team:formation_skipped')
	) {
		incident.state = 'preparing to work';
		incident.stateTime = Q('geo:at_shop', 'geo:at_shop_skipped');
	} else if (Q('geo:at_shop', 'geo:at_shop_skipped') && !Q('team:formed', 'team:formation_skipped')) {
		incident.state = 'at the shop without team';
		incident.stateTime = Q('geo:at_shop', 'geo:at_shop_skipped');
	} else if (Q('team:formed', 'team:formation_call_initiated', 'team:formation_skipped')) {
		incident.state = 'on the way to the shop';
		incident.stateTime = Q('team:formed', 'team:formation_call_initiated', 'team:formation_skipped')
	} else if (Q('contacts:call_completed', 'contacts:call_skipped')) {
		incident.state = 'complainant contacted';
		incident.stateTime = Q('contacts:call_completed', 'contacts:call_skipped');
	} else if (Q('acknowledged')) {
		incident.state = 'acknowledged';
		incident.stateTime = Q('acknowledged');
	} else {
		incident.state = 'new';
		incident.stateTime = incident.time;
	}
}
